// trackEcommerceOrder

export const matomoPurchase = (g_params) => {
  if (!window._paq) {
    setTimeout(() => {
      matomoPurchase(g_params)
    }, 100);
    return
  }
  const { remarketing_params, order_params } = g_params
  for (var i = 0; i < order_params.lineitems.length; i++) {
    window._paq.push(['addEcommerceItem', {
      sku: order_params.lineitems[i].SKU,
      name: order_params.lineitems[i].productName,
      productCategory: order_params.lineitems[i].categoryName,
      price: order_params.lineitems[i].unitPrice,
      quantity: order_params.lineitems[i].quantity
    }]);
  }
  window._paq.push(['trackEcommerceCartUpdate', parseFloat(remarketing_params.ecomm_totalvalue.toFixed(2))]);
  window._paq.push(['trackEcommerceOrder',
    order_params.orderid,
    parseFloat(remarketing_params.ecomm_totalvalue.toFixed(2)),
    order_params.taxAmount,
    0
  ]);
};

export const matomoSetCustomDimension = (dimension, value, retry = 0) => {
  const MAX_RETRIES = 200;
  const RETRY_DELAY = 200;

  if (!window._paq) {
    if (retry < MAX_RETRIES) {
      setTimeout(() => {
        matomoSetCustomDimension(dimension, value, retry + 1);
      }, RETRY_DELAY);
    } else {
      console.warn('Matomo _paq is not available after maximum retries.');
    }
    return;
  }

  window._paq.push(['setCustomDimension', dimension, value]);
  window._paq.push(['trackPageView']);
};


export const matomoSetArrCustomDimension = (arr, retry = 0) => {
  const MAX_RETRIES = 200;
  const RETRY_DELAY = 200;

  if (!window._paq) {
    if (retry < MAX_RETRIES) {
      setTimeout(() => {
        matomoSetCustomDimension(dimension, value, retry + 1);
      }, RETRY_DELAY);
    } else {
      console.warn('Matomo _paq is not available after maximum retries.');
    }
    return;
  }
  arr.forEach((item) => {
    window._paq.push(['setCustomDimension', item.dimension, item.value]);
  });
  window._paq.push(['trackPageView']);
};